import React, {useState, useEffect} from "react";
import {Modal, Form, InputNumber, Switch, Button, Divider} from "antd";

const labelStyle = {marginBottom: 0, fontWeight: 500};

const DefinePoolModal = ({visible, onCancel, onDefine, definingPoolInfo}) => {
    const [form] = Form.useForm();
    const [isReturningCourierAssignActive, setIsReturningCourierAssignActive] = useState(true);
    const [isSupporterCourierAssignActive, setIsSupporterCourierAssignActive] = useState(true);

    useEffect(() => {
        if (visible && definingPoolInfo) {
            const initialSettings = {
                returningCourierAssignIsActive: true,
                returningCourierAssignDistance: 1000,
                supporterPoolCourierAssignIsActive: false,
                supporterPoolCourierAssignDistance: 5,
                supporterPoolCourierAssignWaitTime: 1000,
                ...definingPoolInfo.poolSettings,
            };
            form.setFieldsValue(initialSettings);
            setIsReturningCourierAssignActive(initialSettings.returningCourierAssignIsActive);
            setIsSupporterCourierAssignActive(initialSettings.supporterPoolCourierAssignIsActive);

        } else if (!visible) {
            setIsReturningCourierAssignActive(true);
            setIsSupporterCourierAssignActive(true);
            form.resetFields();
        }
    }, [visible, definingPoolInfo, form]);

    function handleInternalCancel() {
        onCancel();
    }

    return (
        <Modal
            title={
                definingPoolInfo ? `"${definingPoolInfo.name}" Havuzunu Tanımla` : "Havuzu Tanımla"
            }
            visible={visible}
            onCancel={handleInternalCancel}
            destroyOnClose
            footer={null}
            width={500}
        >
            {definingPoolInfo && (
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onDefine}
                    initialValues={{
                        returningCourierAssignIsActive: true,
                        returningCourierAssignDistance: 1000,
                        supporterPoolCourierAssignIsActive: true,
                        supporterPoolCourierAssignDistance: 5,
                        supporterPoolCourierAssignWaitTime: 1000
                    }}
                >
                    <p>
                        <strong>Havuz ID:</strong> {definingPoolInfo.id}
                    </p>
                    <p style={{marginBottom: 20}}>
                        <strong>Havuz Adı:</strong> {definingPoolInfo.name}
                    </p>
                    <Form.Item
                        name="returningCourierAssignIsActive"
                        valuePropName="checked"
                        style={{marginBottom: 8}}
                    >
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Switch
                                size="small"
                                checked={isReturningCourierAssignActive}
                                onChange={(checked) => {
                                    setIsReturningCourierAssignActive(checked);
                                    form.setFieldsValue({ returningCourierAssignIsActive: checked });
                                }}
                            />
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    color: "#888",
                                    fontSize: 13,
                                    marginLeft: 8
                                }}
                            >
                                Geri Dönen Kuryeye Ata
                            </span>
                        </div>
                    </Form.Item>
                    <Form.Item
                        label={<span style={labelStyle}>Geri Dönen Kurye Atama Mesafesi (m)</span>}
                        required={isReturningCourierAssignActive}
                    >
                        <Form.Item
                            name="returningCourierAssignDistance"
                            noStyle
                            rules={[{required: isReturningCourierAssignActive, message: "Lütfen mesafe girin!"}]}
                        >
                            <InputNumber
                                style={{width: "100%"}}
                                min={0}
                                placeholder="Örn: 500"
                                disabled={!isReturningCourierAssignActive}
                            />
                        </Form.Item>
                    </Form.Item>
                    <Divider />
                    <Form.Item
                        name="supporterPoolCourierAssignIsActive"
                        valuePropName="checked"
                        style={{marginBottom: 8}}
                    >
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Switch
                                size="small"
                                checked={isSupporterCourierAssignActive}
                                onChange={(checked) => {
                                    setIsSupporterCourierAssignActive(checked);
                                    form.setFieldsValue({ supporterPoolCourierAssignIsActive: checked });
                                }}
                            />
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    color: "#888",
                                    fontSize: 13,
                                    marginLeft: 8
                                }}
                            >
                                Destekçi Kurye Çek
                            </span>
                        </div>
                    </Form.Item>
                    <Form.Item
                        label={
                            <span style={labelStyle}>
                                Destek İçin Beklenecek Sipariş Süresi (dk)
                            </span>
                        }
                        required={isSupporterCourierAssignActive}
                    >
                        <Form.Item
                            name="supporterPoolCourierAssignWaitTime"
                            noStyle
                            rules={[{required: isSupporterCourierAssignActive, message: "Lütfen süre girin!"}]}
                        >
                            <InputNumber
                                style={{width: "100%"}}
                                min={0}
                                placeholder="Örn: 10"
                                disabled={!isSupporterCourierAssignActive}
                            />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item
                        label="Destekçi Atama Mesafesi (m)"
                        name="supporterPoolCourierAssignDistance"
                        rules={[{required: isSupporterCourierAssignActive, message: "Lütfen mesafe girin!"}]}
                    >
                        <InputNumber
                            style={{width: "100%"}}
                            min={0}
                            placeholder="Örn: 2000"
                            disabled={!isSupporterCourierAssignActive}
                        />
                    </Form.Item>
                    <Form.Item style={{textAlign: "right", marginBottom: 0}}>
                        <Button onClick={handleInternalCancel} style={{marginRight: 8}}>
                            Kapat
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Tanımla
                        </Button>
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
};

export default DefinePoolModal;
